import { render, staticRenderFns } from "./PatientDetails1.vue?vue&type=template&id=3a255f98&scoped=true&"
import script from "./PatientDetails1.vue?vue&type=script&lang=js&"
export * from "./PatientDetails1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a255f98",
  null
  
)

export default component.exports